import React, { useState, useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import StationDetails from "../components/StationDetails.js";
import MainFooterSect from "../../components/MainFooterSect.js";
import TimeSchedule from "../components/TimeSchedule";
import { GET_BROADCASTERS } from "../../components/GraphQL/Queries";
import "./css/page-two.css";
import { Button, Center, ChakraProvider, Spinner } from "@chakra-ui/react";
import { AdvertTypeData } from "../../constant.js";
import moment from "moment";
import "./css/page-two.css";
import {
  advertiserUserType,
  fmtCurrency,
  getCurrencySymbol,
  getCurrencySymbols,
} from "../../utils/functions";
import { request } from "graphql-request";
import { BROADCASTER_SLOTS_GQL } from "../../components/GraphQL/Queries";
import { URL } from "../../config/url";
import { useAtom } from "jotai";
import { loginModalAtom, isBookingState } from "../../atom/advertiserModal";
import { AUTH_TOKEN } from "../../constant.js";
// import { TIME_SCHEDULE } from "../../components/GraphQL/Queries";
import { useCreateDraftFromBookings, useFormatAmount } from "../../hook.js";

import mixpanel from "mixpanel-browser";
import Footer from "../../components/Footer/index.jsx";
import { useParams } from "react-router-dom";
import PreBooking from "../components/PreBooking.jsx";

const PageFour = () => {
  const { loading, createDraft } = useCreateDraftFromBookings();
  const { id } = useParams();
  // login modal
  const [, setLoginModal] = useAtom(loginModalAtom);
  const [, setIsbooking] = useAtom(isBookingState);

  const currency = localStorage.getItem("currency") ?? "NGN";
  const symbol = getCurrencySymbols(currency);
  const formatAmount = useFormatAmount;

  const noOfSelectedStation = 1;

  const [mutatedbroadcasterData, setMutatedBroadcasterData] = useState([]);

  const [broadcasterId, setBroadcasterId] = useState(null);
  const [title, setTitle] = useState("");
  const [activeStation, setActiveStation] = useState(0);
  const [getPrice, setGetPrice] = useState(0);
  const [loadingState, setLoadingState] = useState("idle");
  const [filterData, setFilterData] = useState([]);
  const [tagLine, setTagLine] = useState("");

  //timeschedule modal state
  const [isModal, setIsModal] = useState(false);
  const tokenFromLocalStorage = localStorage.getItem("token");
  const accountType =
    tokenFromLocalStorage && advertiserUserType(tokenFromLocalStorage);

  //get all available rado statons
  const { data } = useQuery(GET_BROADCASTERS, {
    variables: {
      page: 1,
      itemsPerPage: 1000,
      currency,
    },
    onCompleted: (data) => {
      const broadcasterById = data?.guest.getBroadcasters.broadcasters.filter(
        (a) => a.id === id
      )[0];
      const selectedBroadcaster =
        data?.guest.getBroadcasters.broadcasters.filter((a) => {
          return a.id === id;
        })[0];

      setTitle(broadcasterById?.name || "");

      setBroadcasterId(selectedBroadcaster?.id || null);

      setGetPrice(selectedBroadcaster?.startingPrice || 0);

      setTagLine(selectedBroadcaster?.tagLine || "");
    },
  });

  const handleStationButtonClick = (station, index) => {
    setTitle(station.name);
    setActiveStation(index);
    setGetPrice(station.startingPrice);
    setBroadcasterId(station.id);
    setTagLine(station.tagLine);
  };

  useEffect(() => {
    setLoadingState("loading");

    const filteredDataById = data?.guest.getBroadcasters.broadcasters.filter(
      (item) => {
        return item.id === id;
      }
    );
    setFilterData(filteredDataById);

    const filteredDataBySelectedStations =
      data?.guest.getBroadcasters.broadcasters.filter((item) => {
        return item.id === id;
      });

    filteredDataBySelectedStations &&
      Promise.all([
        ...filteredDataBySelectedStations?.map((broadcaster) => {
          return request({
            url: URL,
            document: BROADCASTER_SLOTS_GQL,
            variables: { broadcasterId: broadcaster?.id, currency },
          });
        }),
      ])
        .then((data) => {
          let currDate;

          if (accountType === "Agency") {
            currDate = moment(new Date()).format("YYYY-MM-DD");
          } else {
            currDate = moment(new Date()).add(1, "day").format("YYYY-MM-DD");
          }

          const currentDate = new Date();
          const dateOffset = accountType === "Agency" ? 0 : 1;

          // Create a new date object with the offset
          const adjustedDate = new Date(currentDate);
          adjustedDate.setDate(currentDate.getDate() + dateOffset);

          const currDateFormatted = adjustedDate.toISOString().split("T")[0];

          let mutatedSlotData = [...data].map((broadcaster, i) => {
            broadcaster = { ...broadcaster };
            broadcaster["guest"]["id"] =
              filteredDataBySelectedStations[i]["id"];
            broadcaster["guest"]["name"] =
              filteredDataBySelectedStations[i]["name"];
            broadcaster["guest"]["language"] = "";
            broadcaster["guest"]["duration"] = "";
            broadcaster["guest"]["advertType"] = "";
            broadcaster["guest"]["advertTypeData"] = [...AdvertTypeData];
            broadcaster["guest"]["startDate"] = new Date(currDateFormatted);
            broadcaster["guest"]["endDate"] = new Date(currDateFormatted);
            broadcaster["guest"]["dateRange"] = {};
            broadcaster["guest"]["dateRange"][`${currDate}`] = {
              slotData: [
                ...broadcaster?.guest?.getBroadcasterSlots.map((slot) => {
                  slot = { ...slot };
                  slot["date"] = currDate;
                  slot["adverType"] = null;
                  slot["slotNumber"] = 0;
                  slot["language"] = "";
                  return slot;
                }),
              ],
              totalSlot: 0,
              totalPrice: 0,
            };

            broadcaster["guest"]["totalDays"] = 0;
            broadcaster["guest"]["totalSpots"] = 0;
            broadcaster["guest"]["totalPrice"] = 0;
            broadcaster["guest"]["allSlots"] = [];
            broadcaster["guest"]["isChecked"] = false;
            return broadcaster;
          });
          setLoadingState("completed");

          setMutatedBroadcasterData(mutatedSlotData);
        })
        .catch((err) => console.log(err));
  }, [data]);

  const [language, setLanguage] = useState("");

  const currentBroadcasterData = useMemo(() => {
    if (!mutatedbroadcasterData) return null;

    return mutatedbroadcasterData.find((broadcaster) => {
      return broadcaster?.guest?.name === title;
    })?.guest;
  }, [mutatedbroadcasterData, title]);

  useEffect(() => {
    //prefilleed states with data from array first object

    const selectedStation = data?.guest.getBroadcasters.broadcasters.filter(
      (a) => {
        return a.id === id;
      }
    )[0];

    setTitle(selectedStation?.name || "");

    setBroadcasterId(selectedStation?.id || null);

    setGetPrice(selectedStation?.startingPrice || 0);

    setTagLine(selectedStation?.tagLine || "");
  }, [data]);

  //timeschedule modal function
  const openModal = () => {
    setIsModal(true);
  };

  const closeModal = () => {
    setIsModal(false);
  };

  const allSlotData =
    mutatedbroadcasterData &&
    mutatedbroadcasterData
      ?.map((broadcaster) => {
        return [...(broadcaster.guest?.allSlots || [])];
      })
      .flat()
      .filter(
        (slotData) =>
          slotData?.jingleType !== null || slotData?.slotNumber !== 0
      )
      .map(({ id, slotNumber, date, broadcasterId, advertType, language }) => {
        return {
          slotId: id,
          quantity: slotNumber,
          language: language,
          date: new Date(date),
          broadcasterId: broadcasterId,
          advertType: advertType,
        };
      });

  const handleSubmit = () => {
    // track user event
    mixpanel.track("proceed_to_checkout");

    const token = localStorage.getItem(AUTH_TOKEN);

    // save booking to localstorage
    localStorage.setItem("booking", JSON.stringify(allSlotData));

    if (!token) {
      // set true that a guest a booking a campaign
      setIsbooking(true);

      return setLoginModal(true);
    }

    createDraft([...allSlotData]);
  };

  return (
    <>
      <div>
        <main>
          <section id="station-detail">
            <PreBooking
              filterData={filterData}
              loadingState={loadingState}
              title={title}
              tagline={tagLine}
              totalStation={noOfSelectedStation}
              totalPrice={getPrice}
              id={broadcasterId}
              isOpen={openModal}
              stationNo={filterData?.length}
              broadcasterData={currentBroadcasterData}
              setMutatedBroadcasterData={setMutatedBroadcasterData}
              mutatedbroadcasterData={mutatedbroadcasterData}
              setLanguage={setLanguage}
              broadcasterId={broadcasterId}
              accountType={accountType}
            />
          </section>
        <footer style={{ boxSizing: "content-box" }}>
          <Footer />
        </footer>
        </main>
      </div>
    </>
  );
};

export default PageFour;
